import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

type Props = {
  labels: string[];
  isFolder: boolean;
};

export default function DocumentLabels({ labels, isFolder }: Props) {
  if (isFolder) return null;

  return (
    <Flex alignItems="center" gap={4} flexWrap="wrap">
      {labels.map((label) => (
        <Chip key={label}>
          <Dot />
          {label}
        </Chip>
      ))}
    </Flex>
  );
}

const Chip = styled.span(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  padding: "2px 10px 2px 6px",
  borderRadius: 999,
  border: `1px solid ${theme.colors.sysBorderDecorative}`,
  backgroundColor: theme.colors.sysBackgroundDefault,
  fontSize: 12,
  lineHeight: "20px",
  color: theme.colors.sysTextDefault,
  whiteSpace: "nowrap",
}));

const Dot = styled.span({
  width: 10,
  height: 10,
  borderRadius: "50%",
  backgroundColor: "#C084FC",
  flexShrink: 0,
});
